// **************
// Theme building
// **************

// Helper function for handling assetts in Webpack
function requireAll(r) {
  r.keys().forEach(r);
}

// Handling images for SVG sprite in Webpack
requireAll(require.context("../icons/", true, /\.svg$/));

// Handling images for optimization in Webpack
requireAll(require.context("../images/", true, /\.(png|jpg|jpeg|webp|svg|JPG)$/));

// **************
// Theme fuctions
// **************

// Theme fuctions with support of jQuery
(function ($) {
  $(document).ready(function () {
    // Add sticky class when navbar becomes sticky
    var navbar = $(".region-navbar.page-navbar");
    if (
      navbar.length &&
      window.getComputedStyle(navbar[0]).position === "sticky"
    ) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 1) {
              navbar.addClass("sticky");
            } else {
              navbar.removeClass("sticky");
            }
          });
        },
        { threshold: 1 }
      );

      observer.observe(navbar[0]);
    }

    // keep the mobile disclosure state aligned across visuals, focus and AT
    var mobileMenuBreakpoint = 992;
    var mobileMenuFocusTimer = null;
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var $mobileMenuButton = $("#mobile-menu-button");
    var $navbar = $(".region-navbar.page-navbar");
    var $usernameNavbar = $("#block-mlp-usernamenavbar");
    var $navbarNavigation = $(".page-navbar .block-menu.navigation");
    var $navbarMenu = $navbarNavigation.children(".navbar-menu");

    function setMobileMenuInert(inert) {
      $usernameNavbar.add($navbarMenu).each(function () {
        if (inert) {
          this.setAttribute("inert", "");
        } else {
          this.removeAttribute("inert");
        }
      });
    }

    function setMobileMenuState(open, moveFocus) {
      window.clearTimeout(mobileMenuFocusTimer);
      $mobileMenuButton
        .toggleClass("active", open)
        .attr("aria-expanded", open ? "true" : "false");
      $navbar.toggleClass("mobile-menu-open", open);
      $usernameNavbar.toggleClass("mobile-menu-visible", open);
      $navbarNavigation.toggleClass("mobile-menu-visible", open);

      if ($(window).width() <= mobileMenuBreakpoint) {
        setMobileMenuInert(!open);
      } else {
        setMobileMenuInert(false);
      }

      if (open && moveFocus) {
        var focusDelay = reducedMotion.matches ? 0 : 400;
        mobileMenuFocusTimer = window.setTimeout(function () {
          if ($mobileMenuButton.attr("aria-expanded") === "true") {
            var $focusTarget = $usernameNavbar
              .find("a[href], button:not([disabled])")
              .first();

            if (!$focusTarget.length) {
              $focusTarget = $navbarMenu
                .find("a[href], button:not([disabled])")
                .first();
            }

            $focusTarget.trigger("focus");
          }
        }, focusDelay);
      }
    }

    setMobileMenuState(false, false);

    $(document).on("click", "#mobile-menu-button", function () {
      var open = $(this).attr("aria-expanded") !== "true";
      setMobileMenuState(open, open);
    });

    $(document).on("keydown.mobileMenu", function (event) {
      if (
        event.key === "Escape" &&
        $mobileMenuButton.attr("aria-expanded") === "true"
      ) {
        setMobileMenuState(false, false);
        $mobileMenuButton.trigger("focus");
      }
    });

    // reset the disclosure and restore the desktop navigation on resize
    $(window).resize(function () {
      if ($(window).width() > mobileMenuBreakpoint) {
        setMobileMenuState(false, false);
      } else if ($mobileMenuButton.attr("aria-expanded") !== "true") {
        setMobileMenuInert(true);
      }
    });

    // Initialize menu state based on screen size
    var checkScreenSize = function () {
      var $topUpLogin = $(".top-up-login");
      if ($(window).width() > 768) {
        $topUpLogin.show(); // Always show on desktop
      } else {
        // Hide on mobile unless menu is active
        if (!$("#mobile-menu-button").hasClass("active")) {
          $topUpLogin.hide();
        }
      }
    };

    // Check on load
    checkScreenSize();

    // Check on resize
    $(window).resize(checkScreenSize);

    // Hot News functionality
    var hotnews = {
      running: false,
      wrap: $(".hot-news ul"),
      news: $(".hot-news ul li"),
      actv: "active",
      newsDelay: 7000,
      init: function () {
        if (!this.news.length > 2) {
          return false;
        }

        var lengths = [];
        var indexMax = 0;
        var self = this;

        this.news.each(function (i) {
          lengths.push($(this).text().trim().length);
        });

        $.each(lengths, function (i, v) {
          if (v > lengths[indexMax]) {
            indexMax = i;
          }
        });

        $(this.news[indexMax]).addClass("biggest");
        this.news.first().addClass(this.actv);
        this.wrap.addClass("running");

        setTimeout(function () {
          self.next();
        }, this.newsDelay);
      },
      next: function () {
        var current = this.wrap.find("." + this.actv);
        var next = current.next();
        var self = this;

        current.removeClass(this.actv);

        if (next.length > 0) {
          next.addClass(this.actv);
        } else {
          this.news.first().addClass(this.actv);
        }

        setTimeout(function () {
          self.next();
        }, this.newsDelay);
      },
    };

    // Initialize hot-news if it exists
    if ($(".hot-news").length) {
      hotnews.init();
    }

    // Hot news close functionality
    $(".hot-news-close").on("click", function () {
      $(this).parent().hide();
    });
  });
})(jQuery);

// Theme fuctions with support of Drupal settings, ajax loading and jQuery
(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.MLP_Functions = {
    attach: function (context, settings) {
      // Place your code here
    },
  };
})(jQuery, Drupal, drupalSettings);

// Gallery
(function ($, Drupal, once) {

  Drupal.behaviors.galleryScroll = {
    attach: function (context, settings) {

      // Run only once per .gallery wrapper
      once('galleryScrollInit', '.gallery', context).forEach(function (gallery) {

        const $gallery = $(gallery);
        const $track = $gallery.find('.photoswipe-gallery');

        const step = 157;   // px per click
        let currentOffset = 0;

        // Left + right arrow elements
        const $leftArrow = $gallery.find('.arrow-left');
        const $rightArrow = $gallery.find('.arrow-right');

        /**
         * Updates arrow "active" state depending on scrollability.
         */
        function updateArrows() {
          const trackWidth = $track[0].scrollWidth;
          const containerWidth = $gallery.width();

          // Can scroll right?
          if (trackWidth + currentOffset > containerWidth) {
            $rightArrow.addClass('active');
          } else {
            $rightArrow.removeClass('active');
          }

          // Can scroll left?
          if (currentOffset < 0) {
            $leftArrow.addClass('active');
          } else {
            $leftArrow.removeClass('active');
          }
        }

        /**
         * Scroll right
         */
        $rightArrow.on('click', function () {
          const trackWidth = $track[0].scrollWidth;
          const containerWidth = $gallery.width();

          // Prevent overscrolling
          if (trackWidth + currentOffset > containerWidth) {
            currentOffset -= step;
            $track.css('margin-left', currentOffset + 'px');
            $track.css('transition', 'margin-left 0.3s ease');
            updateArrows();
          }
        });

        /**
         * Scroll left
         */
        $leftArrow.on('click', function () {
          if (currentOffset < 0) {
            currentOffset += step;
            if (currentOffset > 0) currentOffset = 0;
            $track.css('margin-left', currentOffset + 'px');
            updateArrows();
          }
        });

        // Initial state
        updateArrows();
        $(window).on('resize', updateArrows);
      });
    }
  };

})(jQuery, Drupal, once);


// payments history transaction details
((Drupal, once) => {
  'use strict';

  Drupal.behaviors.paymentHistoryDetails = {
    attach(context) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      once('paymentHistoryDetails', '.profile-payments-transaction', context).forEach((details) => {
        const summary = details.querySelector('.profile-payments-transaction__summary');
        const panel = details.querySelector('.profile-payments-transaction__panel');

        if (!summary || !panel) {
          return;
        }

        let animation = null;
        let targetOpen = details.open;

        const finishAnimation = (open) => {
          details.open = open;
          details.classList.remove('profile-payments-transaction--closing');
          panel.style.removeProperty('height');
          panel.style.removeProperty('opacity');
          panel.style.removeProperty('overflow');
          animation = null;
          targetOpen = open;
        };

        summary.addEventListener('click', (event) => {
          // native details behavior is the accessible reduced-motion fallback
          if (reducedMotion.matches || typeof panel.animate !== 'function') {
            targetOpen = !details.open;
            return;
          }

          event.preventDefault();
          targetOpen = !targetOpen;

          // preserve the visible midpoint when a rapid click reverses direction
          const startHeight = details.open ? panel.getBoundingClientRect().height : 0;
          const startOpacity = details.open
            ? Number.parseFloat(window.getComputedStyle(panel).opacity)
            : 0;

          if (targetOpen && !details.open) {
            details.open = true;
          }

          const opening = targetOpen;
          const endHeight = opening ? panel.scrollHeight : 0;
          animation?.cancel();
          details.classList.toggle('profile-payments-transaction--closing', !opening);
          panel.style.overflow = 'hidden';

          animation = panel.animate(
            {
              height: [`${startHeight}px`, `${endHeight}px`],
              opacity: [startOpacity, opening ? 1 : 0],
            },
            {
              duration: 200,
              easing: 'ease-out',
            },
          );

          animation.onfinish = () => {
            if (opening === targetOpen) {
              finishAnimation(opening);
            }
          };
        });
      });
    },
  };
})(Drupal, once);
